import { WarrantyT } from '@lambda/apis/src/warranty/types';
import { useState } from 'react';

const useAddons = ({
  warranty,
}: {
  warranty: { data: WarrantyT | null; loading: boolean };
}) => {
  const [isWarrantySelected, setWarrantySelected] = useState(false);

  const selectedWarranty =
    isWarrantySelected && !warranty.loading ? warranty.data : null;

  return {
    selectedWarranty,
    isWarrantySelected,
    setWarrantySelected,
  };
};

export default useAddons;
